import axios from "axios";
import { URLS } from "./URLS";

export default async function getAccountsAtAddress(
  address_id,
  condo_id,
  isBalance
) {
  let data = [];
  await axios(
    ` ${URLS.url}/${URLS.accountsAtAddressURL}?address_id=${address_id}${
      condo_id ? `&condo_id=${condo_id}` : ""
    }`
  )
    .then((res) => {
      const personalAccounts = res.data.personal_accounts || [];

      let unifiedData = [];

      if (isBalance) {
        // Преобразуем unified_accounts в нужную структуру
        unifiedData =
          res.data.unified_accounts?.map((unifiedItem) => ({
            unified_number: unifiedItem.unified_number,
            id_unified_account: unifiedItem.unified_id,
            first_name: unifiedItem.accounts?.[0]?.first_name, // берем из первого account
            last_name: unifiedItem.accounts?.[0]?.last_name,
            father_name: unifiedItem.accounts?.[0]?.father_name,
          })) || [];
      } else {
        // Для остальных случаев берем все accounts из всех unified_accounts
        unifiedData =
          res.data.unified_accounts?.flatMap((u) => u?.accounts || []) || [];
      }

      data = [...personalAccounts, ...unifiedData];
    })
    .catch(function (error) {
      data.push({ error: "error" });
    });
  //console.log(data);
  return data;
}
